import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ObjectsModalSelectComponent} from './objects-modal-select.component';
import {FormsModule} from '@angular/forms';
import {ModalModule} from '../modal/modal.module';
import {ObjectsModalSelectService} from './objects-modal-select.service';
import {LayoutModule} from '../../layout-components/layout.module';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [
        ObjectsModalSelectComponent
    ],
    exports: [
        ObjectsModalSelectComponent
    ],
    imports: [
        CommonModule, FormsModule, ModalModule, LayoutModule, IconsModule
    ],
    providers: [
        ObjectsModalSelectService
    ]
})
export class ObjectsModalSelectModule {}
